import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=52ce572d&"
import script from "./CommentComponent.vue?vue&type=script&lang=ts&"
export * from "./CommentComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=52ce572d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports